import { useState } from 'react';
import useWindowResize from './useWindowResize';

export default function useWindowWidth() {
    const [width, setWidth] = useState(0);

    useWindowResize(setWidth);
    return width;
}
